import React from 'react';
import { InputBase, IconButton, Tooltip } from '@mui/material';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import { AttachButton, AttachmentChip } from './Attachment';
import '../Assets/css/ChatUI.css';

// Message input card: multi-line text, attachment toolbar and send button
const Composer = ({
  value,
  onChange,
  onSend,
  placeholder,
  showAttach,
  attachment,
  onAttach,
  onRemoveAttachment,
  onAttachError,
  hint,
  autoFocus,
}) => {
  const canSend = Boolean(value.trim() || attachment);

  return (
    <div className="composer">
      <InputBase
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        multiline
        maxRows={8}
        fullWidth
        autoFocus={autoFocus}
        inputProps={{ 'aria-label': 'Message' }}
        onKeyDown={(e) => {
          // Enter sends; Shift+Enter adds a new line
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (canSend) onSend();
          }
        }}
        sx={{ fontFamily: 'Kumbh Sans', fontSize: '16px', lineHeight: 1.6, color: '#1d1b34', padding: '4px 4px 0', '& textarea::placeholder': { color: '#9896ae', opacity: 1 } }}
      />
      <div className="composer-toolbar">
        <div className="composer-left">
          {showAttach && <AttachButton onAttach={onAttach} onError={onAttachError} />}
          {showAttach && attachment && <AttachmentChip attachment={attachment} onRemove={onRemoveAttachment} />}
          {!attachment && hint && <span className="composer-hint">{hint}</span>}
        </div>
        <Tooltip title="Send (Enter)" arrow>
          <span>
            <IconButton
              onClick={onSend}
              disabled={!canSend}
              aria-label="Send message"
              size="small"
              sx={{
                width: 40,
                height: 40,
                color: '#fff',
                background: 'linear-gradient(135deg, #6a4cff, #a07cf7)',
                boxShadow: '0 4px 14px rgba(106, 76, 255, 0.35)',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                '&:hover': { transform: 'translateY(-1px)', boxShadow: '0 6px 18px rgba(106, 76, 255, 0.45)' },
                '&.Mui-disabled': { color: '#fff', background: '#dcd8ea', boxShadow: 'none' },
              }}
            >
              <ArrowUpwardRoundedIcon sx={{ fontSize: 22 }} />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default Composer;
